import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { routes } from './app.routes';
import { AuthGuard, HTTPService } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';
import { ConfProyecto, InterceptorCopecService } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import { loggingInterceptor } from './interceptors/error.interceptor';
import { environment } from 'src/environments/environment';


function initSingletonHTTPService(
  httpService: HTTPService,
  ) {
  return () => {
    return new Promise(async (resolve: any) => {
      HTTPService.instance = httpService

      // Sin level_id, ConfProyecto.init() lo guarda con levelChange('NA') y recarga la página.
      // El webview de la app borra el localStorage en cada apertura, así que se deja antes de init()
      if (localStorage.getItem('level_id') == null) {
        localStorage.setItem('level_id', 'NA');
      }

      //######## CONFIGURACION GENERAL DE LA APLICACION ########
      ConfProyecto.init({
        //TODO path que permitira la llamada que traera las rutas del sistema.
        //TODO modicar las urls que permitira la llamada que traera el menu, logout de la aplicacion, si se ingresan solo los path usuaria el proxy o dominio en el que corre.
        //TODO SE DEBE ACTUALIZAR EL ARCHIVO proxy.conf.json con el domimnio o url cloudfront si es que aun no se define dicho dominio
        // Puede modificar el nombre abreviado de la aplicacion, pathprincipal de navegacion y path del login principal
        application_id: "admin",
        urlMenu: "/",
        urlLogout: undefined,
        nombreAplicacion: "MiApp",
        pathPaginaPrincipal: "/",
        pathLogin: "/",
        pathPerfil: undefined,
        //TODO debes moficiar la llave publica que se genero en KMS a levantar la infraestructura
        public_key: environment.publicKeySeguridad
      })
      //######## FIN CONFIGURACION GENERAL DE LA APLICACION ########

      //######## CONFIGURACION AUTENTIFICACION GOOGLE ########
  
      /**
      permite que al actualizar el navegador y siempre que el email este guardado en localstorage pueda recuperar la sesion
      Si no usuara el modulo de autenticacion de google debe comentar o eliminar la linea.
      */
      //######## FIN CONFIGURACIONES AUTENTIFICACIONES GOOGLE ###########

      resolve()
    });
  };
}
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: 
  [
    AuthGuard,
    HTTPService,
    {
      provide: APP_INITIALIZER,
      useFactory: initSingletonHTTPService,
      multi: true,
      deps: [HTTPService]
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: InterceptorCopecService,
    //   multi: true,
    // },
    provideRouter(routes), 
    provideAnimations(), 
    provideHttpClient(withInterceptors([loggingInterceptor])),
     { provide: LOCALE_ID, useValue: 'es-ES' }

  ]
};
